import { useParams } from 'libs/router'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { HistoryRes } from 'shared/types/general.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchUserHistory = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: userHistory, isPending: isUserHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.users.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.userHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		userHistory,
		isUserHistoryLoading
	}
}
